import { Component, Input } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';

@Component({
    selector: 'app-copyright',
    templateUrl: './copyright.component.html',
    styleUrls: ['./copyright.component.scss'],
    animations: [
        trigger('fade', [
            state('void', style({opacity: 0})),
            transition('void <=> *', [
                animate(300)
            ])
    ])]
})
export class CopyrightComponent {
    @Input()
    public shouldShowFull: boolean = true;
    public currentYear: number = new Date().getFullYear();
}
